import { useSuspenseQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis, FireEyeBehavior } from "../../../../@types";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetBehaviorData = <T extends FireEyeBehavior>(
  hash: string,
  type: T,
  analysis: Analysis
) => {
  const endpoint = route(`api_${analysis}_behavior_${type}`, [hash]);

  const { data } = useSuspenseQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.behaviorData(endpoint),
    queryFn: () => api.getDynamicAnalysisData<Array<unknown>>(endpoint),
    select: ({ data: behaviorData }) => behaviorData
  });

  return { data };
};

export default useGetBehaviorData;
